import React, { useState, useEffect } from "react";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";

const PrintOrderiInfoByBangle = (props) => {
  const navigate = useNavigate();
  console.log(props.status);
  return (
    <>
      <div className="table-icon">
        <PrintIcon
          onClick={() =>
            navigate(
              `/print-report-details-by-bangle/${props.selectedRow?.id}`,
              {
                state: {
                  status:
                    props.status !== undefined ? "complete" : "onprogress",
                },
              }
            )
          }
        />
      </div>
    </>
  );
};

export default PrintOrderiInfoByBangle;
